import "./skeletonStyles.css";

interface Props {
  className?: string;
  count?: number;
}

const SkeletonLoader = ({ className, count = 1 }: Props) => {
  return (
    <>
      {[...Array(count)].map((_, i) => (
        <div key={i} className={`skeleton ${className}`}></div>
      ))}
    </>
  );
};

export default SkeletonLoader;
